import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { getInvertContextMap } from '@utils/common';

export const createFlowConfig = (metricsGroupedByCategory, flowConfigMeta) => {
  const flowConfig = {};
  const currentContext = getInvertContextMap(CURRENT_PRODUCT_MODE);

  Object.keys(flowConfigMeta).forEach((flowId) => {
    const flowMeta = flowConfigMeta[flowId] || {};
    const metricsMeta = metricsGroupedByCategory[currentContext][flowId]
      ? metricsGroupedByCategory[currentContext][flowId]
      : [];
    const metricsOrder = ((flowMeta.metaDefinition || {}).metrics || []).reduce(
      (acc, item) => ({
        ...acc,
        [item.identifier]: item.output_order ?? Infinity,
      }),
      {},
    );

    flowConfig[flowId] = {
      ...flowMeta,
      metricsMeta,
      metricsOrder,
    };
  });

  return flowConfig;
};
